export default __webpack_public_path__ + "static/media/plus-circle.5e6464e1.svg";